import { format } from '@fruitful/fruitils';
import { LabelRegular, YStack } from 'smoothie';

import { LegalLink } from '../common/LegalLink';
import { FootnoteTitle, type FootnoteTitleProps } from './FootnoteTitle';
import {
    DEPOSIT_ACCOUNT_AGREEMENT_LABEL,
    DEPOSIT_ACCOUNT_AGREEMENT_URL,
} from './legal';

export const CashApyDisclosure = ({
    color = '$gray900',
    titleColor,
    superscript,
}: {
    color?: string;
    titleColor?: string;
    superscript?: FootnoteTitleProps['superscript'];
}) => {
    const asOfDate = format(new Date());

    return (
        <YStack>
            <FootnoteTitle
                title="Fruitful Cash"
                superscript={superscript}
                color={titleColor}
            />
            <LabelRegular color={color}>
                The 4.00% Annual Percentage Yield (APY) is only available to
                members with Solo, Joint, Essential, Plus or Premium
                Memberships, otherwise, 3.00% APY will apply. The APYs are
                effective as of {asOfDate}, are variable and may change at any
                time. No minimum balance required. Must have $0.01 in deposits
                to earn interest. Fees may reduce earnings. See{' '}
                <LegalLink href={DEPOSIT_ACCOUNT_AGREEMENT_URL} color={color}>
                    {DEPOSIT_ACCOUNT_AGREEMENT_LABEL}
                </LegalLink>{' '}
                for more details.
            </LabelRegular>
        </YStack>
    );
};
